var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilesPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 302,
    height: 108,
    viewBox: "0 0 302 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 107.707,
    y: 10.5,
    width: 87,
    height: 87,
    rx: 43.5,
    fill: "#F7F7F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 107.707,
    y: 10.5,
    width: 87,
    height: 87,
    rx: 43.5,
    stroke: "#CECEDA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M166.207 45C166.207 44.125 165.926 43.4062 165.363 42.8438C164.801 42.2812 164.082 42 163.207 42H152.238C149.738 41.9375 147.613 41.0625 145.863 39.375L143.332 36.8438L145.488 34.7812L143.332 36.8438C142.77 36.2812 142.082 36 141.27 36H130.207C129.332 36 128.613 36.2812 128.051 36.8438C127.488 37.4062 127.207 38.125 127.207 39V65.9062L131.988 53.8125C132.801 52 134.207 51.0625 136.207 51H173.707C175.27 51.0625 176.52 51.7188 177.457 52.9688C178.27 54.2812 178.426 55.6875 177.926 57.1875L171.926 72.1875C171.113 74 169.707 74.9375 167.707 75H160.207H130.207C128.52 74.9375 127.113 74.3438 125.988 73.2188C124.863 72.0938 124.27 70.6875 124.207 69V39C124.27 37.3125 124.863 35.9062 125.988 34.7812C127.113 33.6562 128.52 33.0625 130.207 33H141.176C142.863 33 144.301 33.5938 145.488 34.7812L147.926 37.2188C149.113 38.4062 150.551 39 152.238 39H163.207C164.895 39.0625 166.301 39.6562 167.426 40.7812C168.551 41.9062 169.145 43.3125 169.207 45V48H166.207V45ZM160.207 72H167.707C168.332 72 168.801 71.6875 169.113 71.0625L175.113 56.0625C175.301 55.5625 175.238 55.0938 174.926 54.6562C174.613 54.2188 174.207 54 173.707 54H136.207C135.582 54 135.113 54.3125 134.801 54.9375L128.801 69.9375C128.613 70.4375 128.676 70.9062 128.988 71.3438C129.301 71.7812 129.707 72 130.207 72H160.207Z",
    fill: "#706B85"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesPlaceholder);
export default __webpack_public_path__ + "static/media/files-placeholder.4714894b7734331b7c357fa2a67a63e2.svg";
export { ForwardRef as ReactComponent };